// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Custom Elements
import { Toast } from "./custom_elements/toast"
customElements.define('toast-notification', Toast)
